import { ImageIcon } from '@phosphor-icons/react';

import { Stack } from '../../../Stack';
import { Paragraph } from '../../../Typography';

export const WebsheetLogoPlaceHolder = () => {
  return (
    <Stack
      direction="row"
      align="center"
      justify="center"
      gap={2}
      className="mx-auto w-fit rounded-lg border-2 border-dashed border-gray-300 px-6 py-4"
    >
      <ImageIcon size={24} aria-hidden className="text-gray-500" />
      <Paragraph color="light" size="lg">
        Your logo
      </Paragraph>
    </Stack>
  );
};
